const stats = [
  { value: "5700+", label: "同人作品" },
  { value: "5", label: "热门IP" },
  { value: "800+", label: "创作者" },
  { value: "98万+", label: "读者" },
];

export default function Hero() {
  return (
    <section
      id="home"
      className="relative flex min-h-screen w-full items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20anime%20illustration%20collage%20of%20popular%20manga%20characters%20silhouettes%20in%20a%20dramatic%20night%20scene%2C%20scattered%20glowing%20paper%20lanterns%20and%20falling%20petals%2C%20bold%20manga%20ink%20brush%20strokes%2C%20deep%20charcoal%20background%20with%20fiery%20crimson%20and%20warm%20gold%20accents%2C%20cinematic%20lighting%2C%20high%20contrast%20editorial%20art%2C%20mysterious%20and%20passionate%20atmosphere&width=1600&height=900&seq=hero-bg&orientation=landscape"
          alt="同人动漫热门IP二创合集氛围背景"
          title="同人动漫合集站"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/80 via-background-950/60 to-background-950"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/70 via-transparent to-background-950/40"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pb-16 pt-28 md:px-6 md:pt-32">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-accent-500/10 px-4 py-1.5 text-sm font-medium text-accent-300">
            <i className="ri-fire-line text-accent-400"></i>
            五大热门IP持续二创更新
          </span>
          <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
            燃尽热血，收藏每一次
            <span className="bg-gradient-to-r from-primary-400 via-accent-400 to-secondary-300 bg-clip-text text-transparent">
              二次元悸动
            </span>
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-foreground-500 md:text-lg">
            火影忍者、海贼王、咒术回战、鬼灭之刃、排球少年等经典作品的同人漫画聚合站。按IP分类整理，持续更新长篇与短篇，帮你在浩瀚的二创宇宙里，快速找到想看的同人故事。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#ips"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-base font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-compass-3-line text-lg"></i>
              浏览热门IP
            </a>
            <a
              href="#featured"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300/50 bg-background-800/40 px-6 py-3 text-base font-bold text-foreground-200 backdrop-blur transition-colors hover:border-accent-400/50 hover:text-accent-300"
            >
              <i className="ri-book-2-line text-lg"></i>
              查看精选合集
            </a>
          </div>

          <dl className="mt-12 grid grid-cols-2 gap-4 border-t border-background-200/40 pt-8 sm:grid-cols-4">
            {stats.map((s) => (
              <div key={s.label}>
                <dt className="order-2 mt-1 text-sm text-foreground-500">{s.label}</dt>
                <dd className="font-heading text-2xl font-black text-accent-400 md:text-3xl">
                  {s.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      <a
        href="#ips"
        aria-label="向下滚动"
        className="absolute bottom-6 left-1/2 z-10 hidden -translate-x-1/2 flex-col items-center gap-1 text-foreground-500 transition-colors hover:text-accent-300 md:flex"
      >
        <span className="text-xs">向下探索</span>
        <i className="ri-arrow-down-line text-lg"></i>
      </a>
    </section>
  );
}